(() => {
  const KLAVIYO_SRC = 'https://static.klaviyo.com/onsite/js/WWeQx3/klaviyo.js?company_id=WWeQx3';
  const LOAD_PROGRESS = 0.15;
  let klaviyoLoaded = false;

  const appendScript = (src, id) => {
    if (document.getElementById(id) || document.querySelector(`script[src="${src}"]`)) return;
    const script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  };

  const loadKlaviyo = () => {
    if (klaviyoLoaded || document.querySelector('script[src*="static.klaviyo.com/onsite/js/WWeQx3/klaviyo.js"]')) return;
    klaviyoLoaded = true;
    window.removeEventListener('scroll', checkProgress);
    appendScript(KLAVIYO_SRC, 'speed-klaviyo-onsite');
  };

  const checkProgress = () => {
    const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    if (window.scrollY / scrollable >= LOAD_PROGRESS) loadKlaviyo();
  };

  if (window.Shopify && Shopify.designMode) {
    loadKlaviyo();
  } else {
    window.addEventListener('scroll', checkProgress, { passive: true });
    checkProgress();
  }
})();

